export const build = { date:"2026-05-29.1323", stage:"alpha" }
